module.exports = __webpack_public_path__ + "images/application/illustrations/servers-white-99bf64f3.svg";